import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, TextField, FormControlLabel, Checkbox } from '@mui/material';
import { useAuth } from '../../contexts';
import './login-sign.scss';
import { TEXT_AUTH_EMAIL, TEXT_AUTH_PASSWORD, TEXT_AUTH_USER } from '../../consts/error-text';

export const SignOn = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();
    const { signIn } = useAuth();
    const handlerName = (value) => setEmail(value);
    const handlerPassword = (value) => setPassword(value);
    const handlerShowPassword = (value) => setShowPassword(value);
    const isDisable = !email || !password;
    const handleSubmit = async (element) => {
        element.preventDefault();
        try {
            setError('');
            await signIn(email, password);
            navigate('/');
        } catch (error) {
            console.log(error.message);
            setError(
                (error.message === 'Firebase: Error (auth/invalid-email).') ?
                    `Помилка при вході. ${TEXT_AUTH_EMAIL}` :
                    (error.message === 'Firebase: Error (auth/wrong-password).') ?
                        `Помилка при вході. ${TEXT_AUTH_PASSWORD}` :
                        (error.message === 'Firebase: Error (auth/user-not-found).') ?
                            `Помилка при вході. ${TEXT_AUTH_USER}` :
                            `Помилка при вході. ${error.message}`
            );
        };
    };

    return (
        <div className='login'>
            <h2 className='login-title'>Увійти</h2>
            {error &&
                <Alert severity='error' sx={{ marginBottom: '16px' }}>
                    {error}
                </Alert>
            }
            <form className='login-form'
                autoComplete='off'
                onSubmit={handleSubmit}>
                <TextField
                    type='text'
                    id='outlined-error'
                    label="Ім'я"
                    placeholder="Введіть ім'я"
                    value={email}
                    onChange={e => handlerName(e.target.value)}
                    sx={{ marginBottom: '20px' }}
                />
                <div className='login-form_password'>
                    <TextField
                        type={showPassword ? 'text' : 'password'}
                        id='outlined-error'
                        label='Пароль'
                        value={password}
                        onChange={e => handlerPassword(e.target.value)}
                        sx={{ marginBottom: '20px' }}
                    />
                    <FormControlLabel control={
                        <Checkbox inputProps={{ 'aria-label': 'Checkbox demo' }}
                            sx={{ color: '#6565f5', '&.Mui-checked': { color: '#6565f5' } }}
                            checked={showPassword}
                            onChange={e => handlerShowPassword(e.target.checked)} />
                    } label='Показати пароль' />
                </div>
                <Button
                    sx={{
                        backgroundColor: '#6565f5',
                        '&:hover': { backgroundColor: '#4d4de9' }
                    }}
                    variant='contained'
                    type='submit'
                    disabled={isDisable}>
                    Увійти
                </Button>
            </form>
        </div>
    )
}